import { atom } from 'recoil';

export const ShowPopoverMoreState = atom({
    key: 'ShowPopoverMoreState', 
    default: false, 
});